<template>
  <div class="main">
    <MainHeader v-if="globalData" :data="globalData" />
    <FooterBtn v-if="$route.name!='unit'" />
    <router-view />
    <MainFooter />
  </div>
</template>

<script>
import MainHeader from "../components/header/MainHeader.vue";
import MainFooter from "../components/footer/MainFooter.vue";
import FooterBtn from "../components/main/FooterBtn.vue";

export default {
  data() {
    return {};
  },
  computed: {
    globalData() {
      return this.$store.getters.getGlobalData;
    }
  },
  mounted() {
    if (this.globalData == null) {
      this.$axios.defaults.headers.common["Accept-Language"] = this.$cookie.get(
        "language"
      )
        ? this.$cookie.get("language")
        : "fa";
      this.$axios.get("front/global").then((res) => {
        let bigData = {
          settings: {},
          keys: {},
          menus: {
            header: [],
            footer: []
          }
        };
        bigData.languages = res.data.home.languages;
        res.data.home.settings.forEach((item) => {
          bigData.settings[item.name] = item.value;
        });
        res.data.home.keys.forEach((item) => {
          bigData.keys[item.key] = item.value;
        });
        res.data.home.menus.forEach((item) => {
          if (item.group_id == 1) {
            bigData.menus.header.push(item);
          } else {
            bigData.menus.footer.push(item);
          }
        });
        console.log(bigData)
        this.$store.commit("setGlobalData", bigData);
      });
    }
  },
  components: { MainFooter, MainHeader, FooterBtn }
};
</script>
<style>
.main {
  overflow: hidden;
}
</style>
